export default __webpack_public_path__ + "static/media/music_marimba_lo_on.e6598725.mp3";